import { OrdersModel } from "one-comp-orderstab";
import { patientStubForOrders } from "one-stubs";

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Orders component
 * @param response is the raw json data returned from API.
 * @param context has settings etc..
 */

export const TransformOrderResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let responseOrders:any = patientStubForOrders();
    let ordersdata: OrdersModel = {};
    let tabdata: any = []
    let result: any = {
        order: ordersdata,
        error: undefined
    }
     if (responseOrders) {
            let info = {
                key:responseOrders?.key,
                created: responseOrders?.Created,
                requestid: responseOrders?.RequestId,
                procedurename: responseOrders?.ProcedureName,
                requestingprovider: responseOrders?.RequestingProvider,
                creationdepartment: responseOrders?.CreationDepartment,
                tag: {
                    type: 'green',
                    name: responseOrders?.Status
                },
                patientpreferredlanguage: responseOrders?.PatientPreferredLanguage,
                visitdeptid: responseOrders?.VisitDeptIDs,
                visittypeid: responseOrders?.VisitTypeIDs,
                specialityid : responseOrders?.SpecialityID,
            }
            tabdata.push(info)
    }
    ordersdata["orderdata"] = tabdata;
    result.order = ordersdata;
    return result;
}